var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-6h24v24H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42 12h5.012c.484 0 .864-.367.864-.833 0-.467-.38-.834-.864-.834H2.42c-.38 0-.692-.3-.692-.666V2.333c0-.366.312-.666.692-.666h5.012c.484 0 .864-.367.864-.834 0-.466-.38-.833-.864-.833H2.42C1.089 0 0 1.05 0 2.333v7.334C0 10.95 1.089 12 2.42 12z",
    fill: "#666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.062 2.833a.878.878 0 0 0-1.227 0 .805.805 0 0 0 0 1.184l1.21 1.166H4.666c-.484 0-.865.367-.865.834 0 .466.38.833.865.833h6.205l-1.037 1a.805.805 0 0 0 0 1.183c.172.167.397.25.605.25A.932.932 0 0 0 11.062 9l2.592-2.5a.805.805 0 0 0 0-1.183l-2.592-2.484z",
    fill: "#666",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.005da8b40f4002aae051db8e3ec386f8.svg";
export { ForwardRef as ReactComponent };